export const environment = {
  appVersion: 'Version 1.5.1+20240109-vapt',
  appName: 'DMS DT V2',
  production: true,
  apiURL: 'https://api-dev-v1.hanumanbeverages.com.kh/dms-dt/',
  apiLink: 'https://api-dev-v1.hanumanbeverages.com.kh/dms-dt/',
  apiURLDms: 'https://api-dev-v1.hanumanbeverages.com.kh/dms-dt/',

  // apiURL: 'http://172.18.6.16:8080/dms-dt/',
  // apiLink: 'http://172.18.6.16:8080/dms-dt/',

  apiUrlIAM: 'https://api-dev-v1.hanumanbeverages.com.kh/iam/v1/',
  apiEncryption: {
    enabled: true,
  },
  storageEncryption: {
    enabled: true,
  },

  keycloak: {
    authority: 'https://login-qas.hanuman.com.kh/realms/hanuman',
    url: 'https://login-qas.hanuman.com.kh',
    realm: 'hanuman',
    clientId: 'hb-ui-dms-depo',
    scope: 'openid profile email organization:hb',
    redirectUri: '/sessions/callback',
    postLogoutRedirectUri: '/',
    enableSsoCheck: true,
    enableSilentSso: false,
    enableIframeSessionChecks: false,
    refreshTokenExpiryWarningSeconds: 30,
  },

};

